import React from "react";
import Image from "next/image";
import Link from "next/link";
import { Remote } from "@/api/loaderRemote";

const VillaOptions = ({ data }) => {
  return (
    <div className="bg-white">
      <div className="py-4">
        <div className="container">
          <div className="flex items-center justify-center mb-4">
            <h1 className="text-3xl font-semibold">{data?.baslik}</h1>
          </div>
          <div className="grid grid-cols-1 gap-2 lg:grid-cols-3 md:grid-cols-2 sm:gap-4">
            {data?._category.map((item) => (
              <Link
                href={item.url}
                key={item.id}
                title={item.title}
                prefetch={false}
                className="relative block overflow-hidden rounded-xl group"
              >
                <Image
                  src={item.resim}
                  width={380}
                  height={235}
                  alt={item.title}
                  loader={Remote}
                  className="object-cover h-[235px] w-full"
                />
                <div className="flex justify-end flex-col h-full w-full left-0 top-0 absolute bg-villaOptions group-hover:bg-[#042b3ead] transition-colors duration-350 ease-in-out text-white lg:p-6 p-3">
                  <div className="flex flex-col md:py-2 md:pl-2">
                    <span className="text-xl font-semibold">{item.baslik}</span>
                    <span>{item.total} Villa</span>
                  </div>
                  <div className="flex items-end flex-auto overflow-hidden transition-all ease-in-out opacity-0 max-h-0 duration-350 group-hover:max-h-full group-hover:opacity-100">
                    <div className="inline-block px-4 py-2 font-semibold text-center text-white transition-all ease-in-out border border-white rounded-xl duration-350 hover:bg-white hover:text-black">
                      <small className="text-sm">Villaları Gör</small>
                    </div>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default VillaOptions;
